// src/client/renderer/shaders/fresnel-rim.ts
import * as THREE from 'three';
import type { ShaderFactory } from './types';
import { VERTEX as RIM_VERTEX, FRAGMENT as RIM_FRAGMENT } from './fresnel-rim.glsl';

export interface FresnelRimUniforms {
  /** Default: (0.55, 0.85, 1.0) cool cyan. */
  uRimColor: THREE.IUniform<THREE.Color>;
  /** Default: (0.15, 0.20, 0.30). */
  uBaseColor: THREE.IUniform<THREE.Color>;
  /** Default: 2.5. */
  uRimPower: THREE.IUniform<number>;
  /** Default: 1.5. */
  uRimIntensity: THREE.IUniform<number>;
}

export const createFresnelRimShader: ShaderFactory = () => {
  const uniforms: FresnelRimUniforms = {
    uRimColor: { value: new THREE.Color(0.55, 0.85, 1.0) },
    uBaseColor: { value: new THREE.Color(0.15, 0.2, 0.3) },
    uRimPower: { value: 2.5 },
    uRimIntensity: { value: 1.5 },
  };
  return new THREE.ShaderMaterial({
    uniforms: uniforms as unknown as Record<string, THREE.IUniform<unknown>>,
    vertexShader: RIM_VERTEX,
    fragmentShader: RIM_FRAGMENT,
  });
};
